// Full & Final (F&F) Settlement — frontend types.
// Mirrors src/api-hr/fnf/models.js + routes.js response shapes exactly.

export type FnfStatus = 'initiated' | 'pending_assets' | 'pending_finance' | 'settled';

export interface AssetRecoveryItem {
  _id: string;
  assetCode: string;
  label: string;
  recovered: boolean;
  recoveredAt: string | null;
  notes: string;
}

export interface FnfSettlement {
  _id: string;
  tenantId: string;
  companyId: string;
  personId: string;
  employeeUserId: string;
  employeeName?: string;
  employeeDepartment?: string;
  exitDate: string;
  lastWorkingDay: string;
  reason: string;
  noticePeriodDays: number;
  noticePeriodServed: number;
  leaveEncashmentDays: number;
  leaveEncashmentAmount: number;
  gratuityAmount: number;
  salaryDues: number;
  deductions: number;
  assetRecovery: AssetRecoveryItem[];
  finalAmount: number;
  status: FnfStatus;
  settledAt: string | null;
  settledBy: string | null;
  notes: string;
  initiatedBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface InitiateFnfPayload {
  employeeUserId: string;
  exitDate: string;
  lastWorkingDay: string;
  reason?: string;
  noticePeriodDays?: number;
  noticePeriodServed?: number;
  assetRecovery?: { assetCode: string; label: string }[];
}

export interface UpdateLedgerPayload {
  leaveEncashmentDays?: number;
  leaveEncashmentAmount?: number;
  gratuityAmount?: number;
  salaryDues?: number;
  deductions?: number;
}

export const FNF_STATUS_LABELS: Record<FnfStatus, string> = {
  initiated: 'Initiated',
  pending_assets: 'Pending Assets',
  pending_finance: 'Pending Finance',
  settled: 'Settled',
};
